/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DomainsControllerCreateMutationRequest, DomainsControllerCreateMutationResponse, DomainsControllerCreate400, DomainsControllerCreate401, DomainsControllerCreate403 } from "../../models/domainsController/DomainsControllerCreate";

function getDomainsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/domains` as const }  
  return res
}

/**
 * @summary Add a domain to an organization
 * {@link /api/v1/domains}
 */
export async function domainsControllerCreate(data?: DomainsControllerCreateMutationRequest, config: Partial<RequestConfig<DomainsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DomainsControllerCreateMutationResponse, ResponseErrorConfig<DomainsControllerCreate400 | DomainsControllerCreate401 | DomainsControllerCreate403>, DomainsControllerCreateMutationRequest>({ method : "POST", url : getDomainsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}